const config = {
    // apiUrl: process.env.REACT_APP_API_URL || 'https://order-management-system.onrender.com/api/v1',
    apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:5000/api/v1',
}

export default config